module.exports = __webpack_public_path__ + "media/application/images/header-arrow-sm-black-5c326951f77c468db971964dd71b8005.svg";